import './teachers.css'
import principal from './principal1.jpg'
import pappuSingh from './pappuSingh.jpg'
import santosh from './santosh.jpg'
import kuldeep from './kuldeep.jpg'
import sukhvir from './sukhvir1.jpg'

export default function Teachers() {
    return (
        <>
            <section className="teachers_page">
                <h1 className="page_title">Principal</h1>
                <div className='principal'>
                    <div className="principal_wrap">
                        <img src={principal} alt="teacher1" />
                        <div className="principal_details">
                            <div className="name">Shri Yogesh Kumar</div>
                            <div className="post">Principal</div>
                            <div className="qualification">M.Sc., B.Ed.</div>
                            <div className="date_of_joining">Date of Joining: 01/12/2005</div>
                        </div>
                    </div>
                </div>
                <h1 className="page_title">Teachers</h1>
                <div className="teachers">
                    <div className='teacher'>
                        <div className="teacher_wrap">
                            <img src={pappuSingh} alt="teacher1" />
                            <div className="teacher_details">
                                <div className="name">Shri Pappu Singh</div>
                                <div className="post">Teacher</div>
                                <div className="qualification">M.A. (Economics), B.Ed.</div>
                                <div className="subject">Subject: Social Science</div>
                                <div className="date_of_joining">Date of Joining: 17/08/2021</div>
                            </div>
                        </div>
                    </div>
                    <div className='teacher'>
                        <div className="teacher_wrap">
                            <img src={kuldeep} alt="teacher1" />
                            <div className="teacher_details">
                                <div className="name">Shri Kuldeep Chandra</div>
                                <div className="post">Teacher</div>
                                <div className="qualification">M.A. (Hindi), B.Ed.</div>
                                <div className="subject">Subject: Hindi</div>
                                <div className="date_of_joining">Date of Joining: 16/08/2021</div>
                            </div>
                        </div>
                    </div>
                    <div className='teacher'>
                        <div className="teacher_wrap">
                            <img src={santosh} alt="teacher1" />
                            <div className="teacher_details">
                                <div className="name">Shri Santosh Kumar</div>
                                <div className="post">Teacher</div>
                                <div className="qualification">B.Sc. (PCM), B.Ed.</div>
                                <div className="subject">Subject: Mathematics</div>
                                <div className="date_of_joining">Date of Joining: 03/11/2020</div>
                            </div>
                        </div>
                    </div>
                    <div className='teacher'>
                        <div className="teacher_wrap">
                            <img src={sukhvir} alt="teacher1" />
                            <div className="teacher_details">
                                <div className="name">Shri Sukha Vir Singh</div>
                                <div className="post">Teacher</div>
                                <div className="qualification">M.A. (English), B.Ed.</div>
                                <div className="subject">Subject: English</div>
                                <div className="date_of_joining">Date of Joining: 26/10/2020</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
